import { safe } from '../utils/contrast.js';
import { txt } from '../utils/dom.js';

export const comparisonBlock = (rawProps, index = 0) => {
    const p = safe(rawProps);
    
    // Valores por defecto seguros si la IA falla
    const headers = p.comparison_headers || ["Característica", "Nosotros", "Alternativas"];
    const rows = p.comparison_rows || [
        { feature: "Diseño Premium", values: ["check", "minus"] },
        { feature: "Soporte 24/7", values: ["check", "minus"] }
    ];
    // Por defecto destacamos la columna 1 (Nosotros)
    const highlightIdx = typeof p.comparison_highlight === 'number' ? p.comparison_highlight : 1;

    // Íconos de respaldo por si fallan los globales
    const iconCheck = window.icons?.check || `<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
    const iconMinus = window.icons?.minus || window.icons?.x || `<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>`;

    const numCols = headers.length;
    
    // --- Construir Thead (Fila de encabezados) ---
    const headerCells = headers.map((h, i) => {
        const isHighlight = i === highlightIdx ? 'col-highlight' : '';
        return `<div class="comp-cell comp-header ${isHighlight}" contenteditable="true" data-header-index="${i}">${txt(h)}</div>`;
    }).join('');

    // --- Construir Filas (Body) ---
    const rowCells = rows.map((r, i) => {
        const valuesArr = Array.isArray(r.values) ? r.values : [r.values];
        
        // Celda: Característica
        let rowHtml = `
            <div class="comp-cell comp-feature-name" data-field="feature" data-item-index="${i}">
                <div contenteditable="true" style="outline:none; padding-left: 20px;">${txt(r.feature)}</div>
            </div>`;
        
        // Celdas: Valores
        const valueCells = valuesArr.map((v, j) => {
            const globalColIdx = j + 1; 
            const isHighlight = globalColIdx === highlightIdx ? 'col-highlight' : '';
            
            const valStr = String(v || '').trim().toLowerCase();
            let stateClass = '';
            let contentHtml = '';

            if (valStr === 'check') {
                stateClass = 'state-check';
                contentHtml = iconCheck;
            } else if (valStr === 'minus' || valStr === 'x') {
                stateClass = 'state-minus';
                contentHtml = iconMinus;
            } else {
                stateClass = 'state-text';
                contentHtml = txt(v);
            }

            // Usamos un botón para ciclar en el editor. El texto será contenteditable si el estado es text.
            const editableAttr = stateClass === 'state-text' ? 'contenteditable="true"' : `data-raw-val="${valStr}"`;
            
            return `
            <div class="comp-cell comp-value ${isHighlight} ${stateClass}" data-val-index="${j}" style="position: relative;">
                <button class="tool-btn variant-btn comp-cycle-btn editor-only" title="Cambiar Check/Minus/Texto" style="position: absolute; top: 4px; right: 4px; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; z-index: 2; padding: 0; opacity: 0; visibility: hidden; transition: 0.2s;">
                    <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
                </button>
                <div class="comp-content" ${editableAttr} style="outline: none;">${contentHtml}</div>
            </div>`;
        }).join('');

        return `
        <div class="comp-row sortable-item" data-array-name="comparison_rows" data-item-index="${i}" style="position: relative; display: grid; grid-template-columns: var(--comp-grid-cols);">
            ${i !== 0 ? `<button class="item-add-btn card-add-top editor-only" data-array="comparison_rows" data-index="${i}" style="position: absolute; left: 50%; transform: translateX(-50%); top: -14px; width: 28px; height: 28px; font-size: 16px; z-index: 100; cursor: pointer;">+</button>` : ''}
            <button class="item-add-btn card-add-bottom editor-only" data-array="comparison_rows" data-index="${i}" style="position: absolute; left: 50%; transform: translateX(-50%); bottom: -14px; width: 28px; height: 28px; font-size: 16px; z-index: 100; cursor: pointer;">+</button>
            <div class="comp-row-tools editor-only">
                <button class="tool-btn item-delete-btn delete-btn" data-array="comparison_rows" data-index="${i}" title="Borrar Fila" style="width: 32px; height: 32px; padding: 0; flex-shrink: 0; justify-content: center; transition: all 0.2s;">${window.icons.trash || iconMinus}</button>
            </div>
            ${rowHtml}
            ${valueCells}
        </div>`;
    }).join('');

    return `
    <style>
        .editor-active .comp-row { transition: z-index 0s; z-index: 1; }
        .editor-active .comp-row:hover { z-index: 50 !important; }
        .editor-active .comp-value:hover .comp-cycle-btn { opacity: 1 !important; visibility: visible !important; }
        .editor-active .comp-row:hover .card-add-top,
        .editor-active .comp-row:hover .card-add-bottom,
        .editor-active .comp-row:hover .comp-row-tools {
            opacity: 1 !important; visibility: visible !important; display: flex !important;
        }
        .comp-row-tools {
            position: absolute; right: 100%; padding-right: 8px; top: 50%; transform: translateY(-50%); z-index: 10; display: flex; flex-direction: column; opacity: 0; visibility: hidden; transition: 0.2s;
        }
        @media (max-width: 768px) {
            .comp-row-tools { right: auto !important; left: -10px !important; top: -10px !important; transform: none !important; }
        }
    </style>
    <section id="bloque-comparison-${index}" class="reveal comparison-section variant-${p.variant || 'v1'} comparison-layout" style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; background-color: var(--bg); color: var(--text); font-family: var(--font);">
        <div class="comparison-container" style="max-width: 1000px; margin: 0 auto; padding: 0 20px;">
            <div class="comparison-header-txt" style="text-align: center; margin-bottom: 60px;">
                <h2 data-field="title" contenteditable="true" style="font-size: calc(clamp(2.5rem, 5cqw, 4rem) * var(--type-scale, 1)); font-weight: 800; margin-bottom: 20px; line-height: 1.05; letter-spacing: -0.03em;">${p.title || 'Comparativa'}</h2>
                <p data-field="subtitle" contenteditable="true" style="font-size: calc(1.25rem * var(--text-scale, 1)); opacity: 0.7; max-width: 600px; margin: 0 auto;">${p.subtitle || 'Por qué somos la mejor opción del mercado'}</p>
            </div>
            
            <div class="comp-grid" style="--comp-grid-cols: 1.5fr repeat(${numCols - 1}, 1fr);">
                <div class="comp-row comp-thead" style="display: grid; grid-template-columns: var(--comp-grid-cols);">
                    ${headerCells}
                </div>
                <div class="comp-tbody" style="display: flex; flex-direction: column;">
                    ${rowCells}
                </div>
            </div>
        </div>
    </section>`;
};
